module.exports = __webpack_public_path__ + "static/media/sort-size-up.9eecd0b4.svg";